// InstructionEdit.jsx
import { useState, useEffect, useMemo, useContext, useRef } from 'react';
import { InstructionEditComponent } from './InstructionEditComponent';

/* ---------- Main component ---------- */
export const InstructionEdit = ({
  state,
  index,
  onModified,
  setStateFn,
  lessonId,
}) => {
  const [newState, setNewState] = useState(state);

  if (!state) return null;
  return (
    <InstructionEditComponent
      state={newState}
      index={index}
      onModified={onModified}
      setStateFn={setStateFn}
      lessonId={lessonId}
      setNewState={setNewState}
    />
  );
};
